<template>
    <div
        class="refund-payment-row"
        :class="{
            'refund-payment-row--selectable': selectable,
            'refund-payment-row--selected': selected,
            'refund-payment-row--plain': plain,
        }"
        @click="selectable && $emit('select')"
    >
        <span
            v-if="selectable"
            class="refund-payment-row__radio mr-3"
            :class="{ 'refund-payment-row__radio--checked': selected }"
        ></span>

        <reference-avatar :reference="title" :index="index" class="mr-3" />

        <div class="refund-payment-row__info">
            <div class="refund-payment-row__title">{{ title }}</div>
            <div class="refund-payment-row__subtitle">{{ subtitle }}</div>
        </div>

        <div class="refund-payment-row__amount">{{ amountLabel }}</div>
    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import ReferenceAvatar from '@/tools/modal/ReservationPayIn/ReferenceAvatar'
import { paymentSubLabel } from '@/utils/refundHelpers'

export default {
    name: 'PaymentRow',
    mixins: [reservationsMixin],
    components: { ReferenceAvatar },
    props: {
        payment: {
            type: Object,
            required: true,
        },
        reservation: {
            type: Object,
            default: null,
        },
        index: {
            type: Number,
            default: 0,
        },
        selectable: {
            type: Boolean,
            default: false,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        // When true the row is rendered as a flat summary (no border / hover / radio).
        plain: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        title() {
            return this.payment.reference || `Payment ${this.index + 1}`
        },
        subtitle() {
            return paymentSubLabel(this.payment, this.reservation)
        },
        amountLabel() {
            return `${this.formatPrice(this.payment.paidValue)} ${this.payment.currency || '€'}`
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    .refund-payment-row {
        display: flex;
        align-items: center;
        padding: 0.75rem 1rem;

        &--selectable {
            border: 1px solid $light;
            border-radius: 0.375rem;
            cursor: pointer;
            transition: border-color 0.15s, background 0.15s;

            &:hover {
                border-color: $color-1;
            }
        }

        &--selected {
            border-color: $color-1;
            background: rgba($color-1, 0.06);
        }

        &--plain {
            background: $lighter;
            border-radius: 0.375rem;
        }
    }

    .refund-payment-row__radio {
        flex: 0 0 auto;
        width: 1.1rem;
        height: 1.1rem;
        border-radius: 50%;
        border: 1px solid $medium;
        position: relative;
        transition: border-color 0.15s;

        &--checked {
            border-color: $color-1;

            &::after {
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 0.6rem;
                height: 0.6rem;
                border-radius: 50%;
                background: $color-1;
            }
        }
    }

    .refund-payment-row__info {
        flex: 1 1 auto;
        min-width: 0;
    }

    .refund-payment-row__title {
        font-size: $font-size-normal;
        font-weight: 600;
        color: $darkest;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .refund-payment-row__subtitle {
        font-size: $font-size-small;
        color: $dark;
    }

    .refund-payment-row__amount {
        flex: 0 0 auto;
        margin-left: 1rem;
        font-weight: 600;
        color: $darkest;
    }
</style>



// WEBPACK FOOTER //
// PaymentRow.vue?54b2619b